module.exports = __webpack_public_path__ + "static/media/cart empty.897b8b72.svg";